import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-list',
  templateUrl: './tutorial-list.component.html',
  styleUrls: ['./tutorial-list.component.scss']
})
export class TutorialListComponent implements OnInit {

  public isEnabled = false;

  constructor() { }

  ngOnInit() {
    this.isEnabled = (window.hasOwnProperty('IS_TUTORIAL_ENABLED') && window['IS_TUTORIAL_ENABLED']);
  }

}
